import React from 'react'
import {FiBox, FiMenu} from 'react-icons/fi'
import {useSelector, useDispatch, shallowEqual} from 'react-redux'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import SvgLogo from './logo-svg'
import {useAppSelector} from '../../redux/store'

import { IconLogo } from '../icons'
import styled from 'styled-components'

const LogoPlace = styled.div`
	box-sizing: border-box;
	margin-bottom: 24px;
	padding: 4px 1px;
	display: flex;
	flex-flow: row nowrap;
	&[data-collapsed="false"] {
		justify-content: flex-start;
	}
	&[data-collapsed="true"] {
		justify-content: center;
	}
	align-items: center;
	color: white;
	letter-spacing: 1.2px;
	text-transform: uppercase;
	font-weight: 700;
`

const LogoLink = styled(Link)`
	box-sizing: border-box;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	overflow: hidden;
`

const LogoName = styled.div`
	box-sizing: border-box;
	display: inline-block;
	opacity: 1;
	width: 196px;
	overflow: hidden;
	font-family: 'Druk Wide', sans-serif;
	text-wrap: nowrap;

	& [data-inv] {
		line-height: 12px;
		font-size: 12px;
	}
	& [data-app] {
		line-height: 10px;
		font-size: 10px;
	}

	&[data-collapsed="true"] {
		opacity: 0;
		width: 0;
	}

	transition: width 0.5s 0s ease-in-out, opacity 0.5s 0s ease-in-out;
`

export const Logo = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch()
	const {settings, uiConfig} = useAppSelector()
	// const {uiConfig} = useSelector(
	//     state => ({
	//         uiConfig: state.uiConfig,
	//     }),
	//     shallowEqual
	// )
	const {collapsed, showLogo} = {...uiConfig}
	//console.log({ collapsed })
	if (!showLogo) return null;
	return (
		<LogoPlace data-collapsed={collapsed}>
			<LogoLink to="/" data-collapsed={collapsed}>
				{/*<FiBox size={28}/>*/}
				<IconLogo size={22} fill="white" />
				<LogoName data-collapsed={collapsed}>
					<div data-inv>Invisible</div>
					<div data-app>pwa</div>
				</LogoName>
				{/* <SvgLogo /> */}
				{/* <span>{settings.project_name}</span> */}
			</LogoLink>
			{/* <button
				onClick={() =>
					dispatch({
						type: 'SET_CONFIG_KEY',
						key: 'collapsed',
						value: !collapsed
					})
				}
				className="ml-auto mr-4 block lg:hidden">
				<FiMenu size={20}/>
			</button> */}
		</LogoPlace>
	)
}

export default Logo
